/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Cat_Backlog_HintInputs */

const en_sch_cat_backlog_hint = /** @type {(inputs: Sch_Cat_Backlog_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not planned yet: ideas and untriaged work.`)
};

const de_sch_cat_backlog_hint = /** @type {(inputs: Sch_Cat_Backlog_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht geplant: Ideen und ungesichtete Arbeit.`)
};

/**
* | output |
* | --- |
* | "Not planned yet: ideas and untriaged work." |
*
* @param {Sch_Cat_Backlog_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_cat_backlog_hint = /** @type {((inputs?: Sch_Cat_Backlog_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Cat_Backlog_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_cat_backlog_hint(inputs)
	return en_sch_cat_backlog_hint(inputs)
});